import React from 'react';

type Props = {
  size: number;
};

const MyProductsIcon = ({ size }: Props) => {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32">
      <g fill="none">
        <path d="M21.875 4c1.313 0 2.516.32 3.61.96a6.913 6.913 0 012.578 2.643c.625 1.121.937 2.354.937 3.7 0 1.226-.269 2.465-.806 3.716a6.98 6.98 0 00-1.94-2.279c.122-.49.183-.969.183-1.437 0-.876-.197-1.666-.593-2.37a4.287 4.287 0 00-1.625-1.65c-.688-.395-1.469-.593-2.344-.593-1.02 0-1.964.294-2.828.881-.865.588-1.474 1.34-1.828 2.258H14.78c-.333-.918-.937-1.67-1.812-2.258-.875-.587-1.813-.88-2.813-.88-.875 0-1.661.197-2.36.592a4.257 4.257 0 00-1.64 1.65c-.396.704-.593 1.494-.593 2.37 0 1.238.427 2.551 1.28 3.94.772 1.238 1.97 2.69 3.595 4.355 1.041 1.068 2.854 2.787 5.437 5.157l.125.128.125-.128c.493-.453.959-.881 1.396-1.287a6.838 6.838 0 002.366 1.378c-.603.571-1.263 1.193-1.98 1.863L16 28.471l-1.875-1.698c-2.792-2.605-4.75-4.495-5.875-5.67-1.77-1.836-3.052-3.47-3.844-4.9C3.47 14.56 3 12.926 3 11.303c0-1.346.318-2.579.953-3.7a7.055 7.055 0 012.578-2.642C7.615 4.32 8.823 4 10.156 4c1.104 0 2.177.256 3.219.769A7.858 7.858 0 0116 6.819a7.858 7.858 0 012.625-2.05A7.27 7.27 0 0121.875 4zm.219 8.157c3.365 0 6.094 2.739 6.094 6.118 0 3.378-2.729 6.117-6.094 6.117-3.366 0-6.094-2.739-6.094-6.117 0-3.38 2.728-6.118 6.094-6.118zm3.067 3.67l-4.406 3.87-1.738-1.523-.58.516 2.318 2.032 4.995-4.378-.59-.517z" />
      </g>
    </svg>
  );
};

export default MyProductsIcon;
